import React, { FC } from 'react'
import { Icon } from 'components/Icon'
import { AreaTools } from 'models/editor'
import { useTranslation } from 'react-i18next'
import { useMapEditorContext, MapEditorWizards } from 'context/map-editor-context'
import { Tooltip } from 'components/Tooltip'

export const TrafficTool: FC = () => {
  const { t } = useTranslation()
  const [{ areaTool }, mapEditorDispatch] = useMapEditorContext()

  return (
    <button
      data-selected={areaTool === AreaTools.TRAFFIC_TOOL ? true : undefined}
      onClick={() => {
        mapEditorDispatch.setWizard(MapEditorWizards.TRAFFIC_TOOL)
        mapEditorDispatch.selectTool(AreaTools.TRAFFIC_TOOL)
      }}
      aria-label={t('map.tools.traffic')}
    >
      <Tooltip label={t(`tooltips.maptools.analisis_trafico`)} direction="LEFT_CENTER">
        <Icon name="traffic-light-line" />
      </Tooltip>
    </button>
  )
}

TrafficTool.displayName = 'TrafficTool'
